const Data = [
    {
      id: 1,
      category: "education",
      icon: "icon-graduation",
      year: "2020 - present",
      title: "Computer Science and Engineering",
      desc: "I am pursuing my graduation degree in computer science and engineering from Sant Longowal Institute of Engineering and Technology, Sangrur(Punjab).",
    },
    {
      id: 2,
      category: "education",
      icon: "icon-graduation",
      year: "2017 - 2020",
      title: "Diploma in Computer Science",
      desc: "I had completed my diploma with 88% from Sant Longowal Institute Of Engineering and Technology, Sangrur(Punjab).",
    },
    {
      id: 3,
      category: "education",
      icon: "icon-graduation",
      year: "2016 - 2017",
      title: "Matriculation",
      desc: "I had completed my matriculation with 95% from Public Central School, khalishpur(Bihar).",
    },
    {
      id: 4,
      category: "training",
      icon: "icon-graduation",
      year: "june 2019",
      title: "Core Java",
      desc: "Training in core Java during the summer term in the 2nd year of diploma  for 4 weeks",
    },
    {
      id: 5,
      category: "training",
      icon: "icon-graduation",
      year: "july 2021",
      title: "Python",
      desc: "Training in Python during summer term in the 2nd year of graduation for 6 weeks.",
    },
    {
      id: 6,
      category: "training",
      icon: "icon-graduation",
      year: "july 2022",
      title: "React JS",
      desc: "Training in React JS during summer term in the pre final year of graduation for 6 weeks.",
    },
  ];

export default Data